module.exports = __webpack_public_path__ + "static/media/5_ChimeKit-Wiring-Setup.f61c9342.svg";